<template>
  <div id="gcs-resumable-container">
    <!-- <div class="table-container col-block" :style="{ height: '40px' }">
      <div class="thead default-shadow">
        <div class="tr row-block">
          <div
            class="th center-block"
            :style="{ width: '140px' }"
          >
            <span>{{ $t('COMPONENT.tool.gcsResumable.gcsTable.title.___caseID') }}</span>
          </div>
          <div
            class="th center-block"
            :style="{ width: '102px' }"
          >
            <span>{{ $t('COMPONENT.tool.gcsResumable.gcsTable.title.___status') }}</span>
          </div>
          <div class="th-center-block" :style="{ flex: 1 }">
            <span></span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="table-container col-block sub-shadow" :style="{ height: '360px' }">
      <div class="tbody" :style="{ flex: 1 }">
        <div :style="{ height: 0 }">
          <div class="tr row-block" v-for="(datas, cindex) in groupFiles" :key="cindex">
            <div class="container-block row-block">
              <div
                class="td center-block"
                :style="{ width: '140px' }"
              >
                <span :title="datas[0].caseData.case_id">{{ datas[0].caseData.case_id }}</span>
              </div>
              <div
                class="td center-block"
                :class="[datas[0].state || 'none']"
                :style="{ width: '102px' }"
              >
                <span>{{ getGroupState(datas) }}</span>
              </div>
              <div v-if="!['error', 'completed'].includes(datas[0].state)" class="icon td center-block" :style="{ flex: 1 }" @click="e => deleteGroup(datas)">
                <img :src="require('../../assets/images/times-regular-white.svg')" alt="">
              </div>
              <div v-else :style="{ flex: 1 }"></div>
              <!-- <div v-if="['uploading'].includes(datas[0].state)" class="icon td center-block" :style="{ flex: 1 }" @click="e => datas.forEach(data => stopUpload(data))">
                <img :src="require('../../assets/images/times-regular-white.svg')" alt="">
              </div>
              <div v-else class="icon td center-block" :style="{ flex: 1 }" @click="e => uploadFile(datas, true)">
                <img :src="require('../../assets/images/cloud-upload-solid.svg')" alt="">
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { API_ROOT } from '../../api/config'
import { postCaseSampleFile } from '../../api'
import toastMethods from '../../mixins/toastMethods'
import customTimeout from '../../mixins/customTimeout.vue'
import { groupBy, dateFormat, cleanObject, toFormdata } from '../../constants/global/util'
import { _LOCAL_BUILD } from '../../constants/global/config'

export default {
  mixins: [
    toastMethods,
    customTimeout
  ],
  data () {
    return {
      uploadThreadDatas: [],
      metadata: {
      }
    }
  },
  computed: {
    ...mapGetters([
      'isFileUpload',
      'uploadCount',
      'waitUploading',
      'isLogin',
      'user'
    ]),
    uploadingCaseIDs () {
      return this.groupFiles.map(datas => datas[0].caseData.id)
    },
    groupFiles () {
      const groupRule = data => {
        let groupName = this.getGroupName(data)
        Object.values(this.metadata).forEach(m => {
          m[groupName] = m[groupName] || ''
        })
        return groupName
      }
      return groupBy(this.uploadThreadDatas, groupRule)
    }
  },
  async created () {
    this.userData = this.user
    try {
      if (!_LOCAL_BUILD) {
        for (let data of Object.values(this.getResumableInfo())) {
          let state = await this.getUploadState(data)
          if (state) {
            this.uploadThreadDatas.push({
              ...data,
              ...state,
              state: state.loaded < data.file.size ? 'stop' : 'completed'
            })
          }
        }
      }
    } catch (error) {
      this.addToast('error', !error.response ? error.message : error.response.data.result.message)
    }
    // this.$ls.set('resumableInfo', {})
  },
  beforeDestroy () {
    this.uploadThreadDatas.filter(data => ['uploading'].includes(data.state)).forEach(data => {
      this.stopUpload(data)
      this.cancelFile(data)
    })
  },
  watch: {
    'waitUploading' (nv) {
      if (nv) {
        this.selectFiles(nv.caseData, nv.fileSets)
      }
      this.setWaitUploadingAction()
    },
    'isLogin' (nv) {
      if (nv === false) {
        this.deleteGroup(this.uploadThreadDatas)
      }
    },
    'groupFiles.length' (nv, ov) {
      nv > ov && this.$emit('count')
    }
  },
  methods: {
    ...mapActions([
      'addUploadCountAction',
      'setWaitUploadingAction',
      'setResumableInfoAction'
    ]),
    // selectFiles (e) {
    //   const s = dateFormat(new Date(), 'yyyyMMddhhmmssS')
    //   this.uploadThreadDatas = this.uploadThreadDatas.concat(Array.from(e.target.files).map(file => ({
    //     file: file,
    //     groupTime: s,
    //     extention: file.name.split('.').reverse()[0]
    //   })))
    //   e.target.value = ''
    // },
    async selectFiles (caseData, fileSets) {
      if (!this.uploadingCaseIDs.includes(caseData.id)) {
        const s = dateFormat(new Date(), 'yyyyMMddhhmmssS')
        let config = this.$ls.get('userInfo')
        let datas = []
        let signUrls = await this.getSignUrl(caseData, fileSets)
        fileSets.forEach((set, index) => {
          if (caseData.dataset === 'vcf') {
            if (signUrls[index].snv) {
              datas.push({
                file: set.snv,
                signUrl: signUrls[index].snv.startsWith('https://storage.googleapis.com/') ? signUrls[index].snv : (API_ROOT + signUrls[index].snv.replace(/^\//, '') + '?access_token=' + config['access_token']),
                caseData: caseData,
                groupTime: s,
                extention: set.snv.name.split('.').reverse()[0]
              })
            }
            if (signUrls[index].sv) {
              let urlMap = signUrls[index].sv.reduce((map, data) => ({ ...map, ...data }), {})
              set.sv.forEach(file => {
                let signUrl = urlMap[file.name]
                if (signUrl) {
                  datas.push({
                    file: file,
                    signUrl: signUrl.startsWith('https://storage.googleapis.com/') ? signUrl : (API_ROOT + signUrl.replace(/^\//, '') + '?access_token=' + config['access_token']),
                    caseData: caseData,
                    groupTime: s,
                    extention: file.name.split('.').reverse()[0]
                  })
                }
              })
            }
            if (signUrls[index].str) {
              datas.push({
                file: set.str,
                signUrl: signUrls[index].str.startsWith('https://storage.googleapis.com/') ? signUrls[index].str : (API_ROOT + signUrls[index].str.replace(/^\//, '') + '?access_token=' + config['access_token']),
                caseData: caseData,
                groupTime: s,
                extention: set.str.name.split('.').reverse()[0]
              })
            }
          } else if (caseData.dataset === 'fastq') {
            datas.push({
              file: set.r1,
              signUrl: signUrls[index].r1.startsWith('https://storage.googleapis.com/') ? signUrls[index].r1 : (API_ROOT + signUrls[index].r1.replace(/^\//, '') + '?access_token=' + config['access_token']),
              caseData: caseData,
              groupTime: s,
              extention: set.r1.name.split('.').reverse()[0]
            })
            if (caseData.pipelineType === 'paired') {
              datas.push({
                file: set.r2,
                signUrl: signUrls[index].r2.startsWith('https://storage.googleapis.com/') ? signUrls[index].r2 : (API_ROOT + signUrls[index].r2.replace(/^\//, '') + '?access_token=' + config['access_token']),
                caseData: caseData,
                groupTime: s,
                extention: set.r1.name.split('.').reverse()[0]
              })
            }
          }
        })
        this.uploadThreadDatas = this.uploadThreadDatas.concat(datas)
        await this.uploadFile(datas)
      } else {
        let datas = this.uploadThreadDatas.filter(data => data.caseData.id === caseData.id)
        this.completeFile(fileSets, datas)
      }
    },
    async uploadFile (datas, isResume = false) {
      if (!datas.some(data => !data.state || ['stop', 'error'].includes(data.state))) {
        return false
      }
      // if (datas.some(data => !data.signUrl)) {
      //   const signUrls = await this.getSignUrl(datas)
      //   for (let i = 0; i < datas.length; i++) {
      //     if (signUrls[i]) {
      //       datas[i] = this.refreshData(datas[i], { signUrl: signUrls[i].url })
      //       this.saveResumableInfo(datas[i])
      //     }
      //   }
      // }
      for (let i = 0; i < datas.length; i++) {
        if (!datas[i].state) {
          datas[i] = this.refreshData(datas[i], { state: 'stop' })
          this.saveResumableInfo(datas[i])
        }
      }
      if (datas.every(data => data.signUrl)) {
        for (let i = 0; i < datas.length; i++) {
          if (!datas[i].state || ['stop', 'error'].includes(datas[i].state)) {
            let state = await this.getUploadState(datas[i])
            if (state && (!isResume || (state.loaded >= datas[i].loaded))) {
              datas[i] = this.refreshData(datas[i], state)
            } else {
              return true
            }
          }
        }
        for (let i = 0; i < datas.length; i++) {
          if (!datas[i].state || ['stop', 'error'].includes(datas[i].state)) {
            this.postFile(datas, i)
          }
        }
        return false
      } else {
        // this.addToast('error', this.$t('COMMON.toast.___getSignUrlFailed'))
      }
    },
    async getSignUrl (caseData, fileSets) {
      try {
        let config = this.$ls.get('userInfo', {})
        let id = caseData.id
        let dataset = caseData.dataset
        let data = {}
        if (caseData.dataset === 'vcf') {
          data.vcf_file = cleanObject({
            snv: fileSets[0].snv ? {
              name: fileSets[0].snv.name,
              content_type: fileSets[0].snv.type || 'text/plain'
            } : null,
            sv: fileSets[0].sv ? fileSets[0].sv.map(file => ({
              name: file.name,
              content_type: file.type || 'text/plain'
            })) : null,
            str: fileSets[0].str ? {
              name: fileSets[0].str.name,
              content_type: fileSets[0].str.type || 'text/plain'
            } : null
          })
        } else if (caseData.dataset === 'fastq') {
          data.omics = caseData.omics_name
          data.pipeline = caseData.pipeline_name
          data.library_type = caseData.library_type_name
          data.ngs_files = fileSets.map(set => ({
            r1: {
              name: set.r1.name,
              content_type: set.r1.type || 'text/plain'
            },
            ...(caseData.pipelineType === 'paired' ? {
              r2: {
                name: set.r2.name,
                content_type: set.r2.type || 'text/plain'
              }
            } : {})
          }))
        }
        let response = await postCaseSampleFile(id, dataset, data, config)
        let signUrls = response.data.data
        return caseData.dataset === 'vcf' ? [signUrls] : signUrls
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    async getUploadState (data) {
      let status = data.signUrl ? data.signUrl.startsWith('https://storage.googleapis.com/') ? await new Promise(resolve => {
        let xhr = this.createCORSRequest('PUT', data.signUrl)
        if (xhr.upload) {
          xhr.onerror = e => {
            resolve(null)
          }
          xhr.onload = e => {
            let headers = xhr.getAllResponseHeaders().split('\n').reduce((s, c) => ({ ...s, ...{ [c.split(': ')[0]]: c.split(': ')[1] } }), {})
            let loaded = headers['range'] ? headers['range'].replace('bytes=0-', '') - -1 : 0
            resolve({
              loaded: loaded,
              curLoaded: 0
            })
          }
          xhr.setRequestHeader('Content-Type', data.file.type || 'text/plain')
          xhr.setRequestHeader('Content-Range', 'bytes */' + data.file.size)
          xhr.send()
        }
      }) : {
        loaded: 0,
        curLoaded: 0
      } : null
      return status
    },
    postFile (datas, i) {
      let xhr = this.createCORSRequest('PUT', datas[i].signUrl)
      if (xhr.upload) {
        xhr.upload.addEventListener('progress', e => {
          if (e.lengthComputable) {
            datas[i] = this.refreshData(datas[i], { curLoaded: e.loaded })
          }
        }, false)
        xhr.onload = e => {
          datas[i] = this.refreshData(datas[i], { state: 'completed' })
          if (datas.every(data => ['completed'].includes(data.state))) {
            for (let i = 0; i < datas.length; i++) {
              this.removeResumableInfo(datas[i])
            }
            this.$emit('complete')
            this.addUploadCountAction(true)
          }
        }
        xhr.onerror = () => {
          datas[i] = this.stopUpload(datas[i], true)
          if (datas.every(data => ['completed', 'error'].includes(data.state))) {
            this.customRecursive(async () => {
              let result = datas.every(data => this.getResumableInfo()[data.signUrl]) ? await this.uploadFile(datas, true) : false
              return result
            }, 10 * 1000)
          }
        }
        if (datas[i].signUrl.startsWith('https://storage.googleapis.com/')) {
          xhr.setRequestHeader('Content-Type', datas[i].file.type || 'text/plain')
          if (datas[i].loaded > 0) {
            xhr.setRequestHeader('Content-Range', 'bytes ' + datas[i].loaded + '-' + (datas[i].file.size - 1) + '/' + datas[i].file.size)
          }
        }
        let file = datas[i].loaded === 0 ? datas[i].file : datas[i].file.slice(datas[i].loaded, datas[i].file.size)
        datas[i] = this.refreshData(datas[i], {
          xhr: xhr,
          state: 'uploading'
        })
        xhr.send(datas[i].signUrl.startsWith('https://storage.googleapis.com/') ? file : toFormdata({ file: file }))
      } else {
        this.addToast('error', this.$t('COMMON.toast.___xhrCanNotUpload'))
      }
    },
    stopUpload (data, isError = false) {
      if (['uploading'].includes(data.state)) {
        data = this.refreshData(data, {
          loaded: data.curLoaded + data.loaded,
          curLoaded: 0,
          state: isError ? 'error' : 'stop'
        })
        data.xhr.abort()
      }
      return data
    },
    cancelFile (data) {
      this.removeResumableInfo(data)
      this.uploadThreadDatas.splice(this.uploadThreadDatas.indexOf(data), 1)
    },
    completeFile (fileSets, datas) {
      let files = Array.prototype.concat.apply([], fileSets.map(set => Object.values(set)))
      if (files.length === datas.length) {
        for (let i = 0; i < datas.length; i++) {
          let index = files.map(file => file.name + '_' + file.type + '_' + file.size).indexOf(datas[i].file.name + '_' + datas[i].file.type + '_' + datas[i].file.size)
          if (index !== -1) {
            datas[i] = this.refreshData(datas[i], {
              file: files[index]
            })
          } else {
            break
          }
        }
      }
      if (datas.every(data => ['completed'].includes(data.state) || data.file.lastModified)) {
        for (let i = 0; i < datas.length; i++) {
          if (!datas[i].state || ['stop', 'error'].includes(datas[i].state)) {
            this.postFile(datas, i)
            this.saveResumableInfo(datas[i])
          }
        }
      } else {
        this.addToast('error', this.$t('COMMON.toast.___wrongFiles'))
      }
    },
    saveResumableInfo (data) {
      let info = this.$ls.get('resumableInfo') || {}
      info[this.userData.email] = info[this.userData.email] || {}
      info[this.userData.email][data.signUrl] = {
        ...data,
        file: {
          name: data.file.name,
          type: data.file.type,
          size: data.file.size
        }
      }
      this.$ls.set('resumableInfo', info)
      this.setResumableInfoAction(info)
    },
    getResumableInfo () {
      let info = this.$ls.get('resumableInfo') || {}
      return info[this.userData.email] || {}
    },
    removeResumableInfo (data) {
      let info = this.$ls.get('resumableInfo') || {}
      if (info[this.userData.email] && info[this.userData.email][data.signUrl]) {
        delete info[this.userData.email][data.signUrl]
        this.$ls.set('resumableInfo', info)
        this.setResumableInfoAction(info)
      }
    },
    createCORSRequest (method, url) {
      let xhr = new XMLHttpRequest()
      if ('withCredentials' in xhr) {
        xhr.open(method, url, true)
      } else if (typeof XDomainRequest !== 'undefined') {
        xhr = new XDomainRequest()
        xhr.open(method, url)
      } else {
        xhr = null
      }
      return xhr
    },
    refreshData (data, _data) {
      if (!_data || !Object.values(_data).length) return data
      let index = this.uploadThreadDatas.indexOf(data)
      this.$set(this.uploadThreadDatas, index, { ...data, ..._data })
      return this.uploadThreadDatas[index]
    },
    getGroupName (data) {
      let s = data.groupTime || this.dateFormat(new Date(), 'yyyyMMddhhmmssS')
      return data.caseData.id + '_' + (s || '')
    },
    getGroupState (group) {
      let sum = group.reduce((s, c) => s + this.getFilePersent(c), 0) / group.length
      let state = group[0].state
      return {
        uploading: Math.round(sum) + '%',
        stop: this.$t('COMPONENT.tool.gcsResumable.groupState.___pending'),
        error: this.$t('COMPONENT.tool.gcsResumable.groupState.___failed'),
        completed: '100%'
      }[state] || this.$t('COMPONENT.tool.gcsResumable.groupState.___pending')
    },
    getFilePersent (data) {
      return !data.signUrl ? 0 : Math.round(data.file.size ? (((data.curLoaded + data.loaded) || 0) * 100) / data.file.size : data.loaded !== undefined ? 100 : 0)
    },
    deleteGroup (datas) {
      this.$emit('cancel', datas.every(data => ['completed'].includes(data.state)))
      datas.forEach(data => {
        // this.stopUpload(data)
        if (['uploading'].includes(data.state)) {
          data.xhr.abort()
        }
        this.cancelFile(data)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
#gcs-resumable-container
  height: 100%
  ::-webkit-scrollbar 
    width: 6px
    height: 6px
    background: #777777
    border: 0.5px solid #777777
    -webkit-border-radius: 3px
    border-radius: 3px
  ::-webkit-scrollbar-track 
    margin: 1px 0
  ::-webkit-scrollbar-thumb 
    -webkit-border-radius: 3px
    border-radius: 3px
    background: white
  .table-container
    width: 100%
    // height: 0
    overflow: auto
    border-top: 1px solid #E8E8E8
    & > div
      width: 100%
    .thead
      .tr
        height: 40px
        .th
          box-sizing: border-box
          height: 100%
          padding: 0
          font-weight: bold
          text-align: center
          span
            padding: 0 10px
            color: white
    .tbody
      overflow: auto
      .tr
        height: 40px
        // cursor: pointer
        &:nth-child(2n)
          // background: #F8FAFA
        &:hover
          // background: white
          // box-shadow: 0 4px 8px rgba(5, 2, 2, 0.16)
          // z-index: 10
          // & > div
          //   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16)
          // .td:first-child
          //   border-left: 4px solid #003679
          //   border-right: 4px solid transparent
        .td
          box-sizing: border-box
          height: 100%
          padding: 0
          overflow: hidden
          &.none
            color: white
          &.uploading
            color: #83C91E
          &.stop
            color: white
          &.error
            color: #FA3D3D
            font-weight: bold
          &.completed
            color: white
            font-weight: bold
          &.icon
            cursor: pointer
          span
            padding: 0 10px
            overflow: hidden
            white-space: nowrap
            text-overflow: ellipsis
</style>



// WEBPACK FOOTER //
// src/components/tool/gcsResumable.vue